import { mode } from "./type";

import styles from "./Feedback.module.scss";

export const ModeToClassName: Record<mode, string> = {
  primary: styles.primary,
  danger: styles.danger,
};
